module.exports = __webpack_public_path__ + "static/media/Daniel1.2802f65d.jpg";